import { useRecoilValue } from "recoil";
import upperDataStore from "../stores/upperData";

export const useBalance = () => {
    const { balance } = useRecoilValue(upperDataStore);
    return balance;
};